import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#061AB1",
  stroke: "#EBEBEB",
  d: "M22.867.5H3.133A2.633 2.633 0 0 0 .5 3.133v11.734A2.633 2.633 0 0 0 3.133 17.5h19.734a2.633 2.633 0 0 0 2.633-2.633V3.133A2.633 2.633 0 0 0 22.867.5Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFD100",
  d: "M22.253 12.482c.599 0 1.08-.48 1.08-1.065 0-.598-.481-1.065-1.08-1.065-.599 0-1.08.48-1.08 1.065a1.091 1.091 0 0 0 1.08 1.065"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M7.099 9.027v1.403H8.27c-.169.272-.56.415-.82.415-.885 0-1.328-.494-1.328-1.507 0-1.117.586-1.688 1.732-1.688.455 0 1.054.117 1.705.311V6.286c-.182-.078-.469-.143-.833-.208A6.978 6.978 0 0 0 7.763 6c-1.146 0-2.058.312-2.734.922C4.339 7.532 4 8.364 4 9.403c0 .961.26 1.715.794 2.26.534.559 1.25.845 2.148.845.899 0 1.732-.468 2.005-1.052v.948h1.302V9.027zm3.788 3.377v-6.3h2.031v4.663h2.213v1.637zm4.882-.156v-1.715c.3.091.651.182 1.055.247.39.065.742.104 1.028.104.495 0 .755-.117.755-.338 0-.143-.078-.207-.442-.285l-.703-.156c-1.211-.273-1.77-.884-1.77-1.91 0-.675.233-1.208.702-1.61.469-.39 1.12-.585 1.94-.585.56 0 1.432.117 1.953.247v1.636c-.273-.064-.599-.142-1.003-.207a5.877 5.877 0 0 0-.937-.091c-.43 0-.677.117-.677.337 0 .13.117.221.352.286l.82.195c1.198.286 1.757.896 1.757 1.935 0 .663-.247 1.196-.729 1.585-.481.39-1.158.585-2.005.585-.82 0-1.64-.117-2.096-.26"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }